import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade } from 'swiper/modules';


import 'swiper/css';
import 'swiper/css/effect-fade';

import Header from '../Component/Header';
import Footer from '../Component/Footer';

import CommunityImpact from "../Components/CommunityImpact";
import Homeupcomingmeet from "../Components/Homeupcomingmeet";
import HomeLocalocalexpertlist from "../Components/HomeLocalocalexpertlist";
import Homeupcominggrouptrips from "../Components/Homeupcominggrouptrips";
import Homecommunitylist from "../Components/Homecommunitylist";
import MoHomecommunitylist from "../Components/MoHomecommunitylist";
import MoHomeupcominggrouptrips from "../Components/MoHomeupcominggrouptrips";
import MoHomeupcomingmeet from "../Components/MoHomeupcomingmeet";
import HomeJourneys from "../Components/HomeJourneys";
import HomeBanner from "../Components/HomeBanner";
import HomeDestinations from "../Components/HomeDestinations";
import Homereviewlist from "../Components/Homereviewlist";
import MoHomereviewlist from "../Components/MoHomereviewlist";
import { API_BASE } from "../api/apiConfig";

const Index = () => {
    // Mob
     const [tripTab, setTripTab] = useState("international");

    const [showFilters, setShowFilters] = useState(false);

  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);

  const slidesData = [
    {
      imgSrc: "/assets/images/rajasthan-desert-community-travelers.jpg",
      alt: 'Rajasthan Desert',
      title: 'Found my travel family in the golden dunes! 🐪',
      name: 'Priya from Mumbai',
      timeAgo: '2h ago',
      likes: 234,
      comments: 45,
      shares: 3,
    },
    {
      imgSrc: "/assets/images/kerala-backwaters-community-travelers.jpg",
      alt: 'Kerala Backwaters',
      title: 'Local fisherman taught us traditional songs 🎵',
      name: 'Alex from Delhi',
      timeAgo: '5h ago',
      likes: 189,
      comments: 32,
      shares: 4,
    },
    {
      imgSrc: "/assets/images/himachal-mountains-community-travelers.jpg",
      alt: 'Himachal Mountains',
      title: 'Sunrise with strangers who became sisters ⛰️',
      name: 'Meera from Bangalore',
      timeAgo: '1d ago',
      likes: 312,
      comments: 67,
      shares: 5,
    },
  ];

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
  };

  const handleDotClick = (index) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideToLoop(index);
    }
  };

  const [activeTab, setActiveTab] = useState('home');

  return (
    <>
      <Header />

        <div className='hidden sm:block'>
            <main className="min-h-screen overflow-hidden mobile-optimized">

                


             
<HomeBanner />

<HomeJourneys />


                {/* <Homeupcomingmeet /> */}

                <Homeupcominggrouptrips />



{/* Top Destinations New Code */}
<HomeDestinations />
{/* ./Top Destinations New Code */}

{/* Why Trust New Code */}
<section className="relative w-full overflow-hidden bg-gradient-to-b from-white via-slate-50/50 to-white py-10 md:py-14">
  <div className="container relative z-10 mx-auto px-4 md:px-6">
    <div className="text-center mb-8">
      <div className="inline-flex items-center gap-1.5 rounded-full bg-primary/10 border border-primary/20 px-3 py-1 text-xs font-medium text-primary mb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-shield h-3 w-3"
        >
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
        </svg>
        <span>Trusted by 10,000+ Travellers</span>
      </div>
      <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mb-3">
        Why Trust <span className="text-primary">Connecting Traveller</span>
      </h2>
      <div className="flex gap-3 justify-center">
        <div className="rounded-xl bg-primary/5 border border-primary/15 px-4 py-2 text-center">
          <p className="text-xl font-bold text-primary leading-tight">10K+</p>
          <p className="text-[10px] text-slate-500">Travellers</p>
        </div>
        <div className="rounded-xl bg-primary/5 border border-primary/15 px-4 py-2 text-center">
          <p className="text-xl font-bold text-primary leading-tight">24/7</p>
          <p className="text-[10px] text-slate-500">Support</p>
        </div>
        <div className="rounded-xl bg-primary/5 border border-primary/15 px-4 py-2 text-center">
          <p className="text-xl font-bold text-primary leading-tight">100%</p>
          <p className="text-[10px] text-slate-500">Transparent</p>
        </div>
      </div>
    </div>
    <div className="mx-auto max-w-6xl">
      <div className="grid gap-8 md:grid-cols-[280px_1fr]">
        <div className="flex flex-col">
          <div className="w-full max-w-[280px] mx-auto">
            <div className="relative rounded-[2.5rem] border-[4px] border-slate-800 bg-slate-800 p-1.5 shadow-2xl">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-5 bg-slate-800 rounded-b-xl z-10" />
              <div className="rounded-[2rem] overflow-hidden bg-[#efeae2]">
                <div className="bg-[#075E54] px-3 pt-7 pb-2.5 flex items-center gap-2.5">
                  <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                    <span className="text-white text-[10px] font-bold">CT</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-white text-xs font-semibold truncate">
                      Connecting Traveller
                    </p>
                    <p className="text-white/60 text-[9px]">online</p>
                  </div>
                </div>
                <div className="px-2.5 py-2.5 space-y-1.5">
                  <div className="flex justify-center">
                    <span className="text-[9px] bg-white/80 text-slate-500 px-2.5 py-0.5 rounded-full shadow-sm">
                      Today
                    </span>
                  </div>
                  <div className="flex justify-start">
                    <div className="bg-white rounded-xl rounded-tl-sm px-3 py-1.5 max-w-[85%] shadow-sm">
                      <p className="text-[11px] text-slate-800">
                        Your Spiti Valley trip is confirmed! Pickup at 6 AM
                        tomorrow.
                      </p>
                      <span className="text-[8px] text-slate-400 block text-right mt-0.5">
                        9:41 AM
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <div className="bg-[#DCF8C6] rounded-xl rounded-tr-sm px-3 py-1.5 max-w-[75%] shadow-sm">
                      <p className="text-[11px] text-slate-800">
                        Great! What's the pickup point?
                      </p>
                      <div className="flex items-center justify-end gap-0.5 mt-0.5">
                        <span className="text-[8px] text-slate-400">
                          9:42 AM
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-check-circle h-2.5 w-2.5 text-blue-500"
                        >
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                          <path d="m9 11 3 3L22 4" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-start">
                    <div className="bg-white rounded-xl rounded-tl-sm px-3 py-1.5 max-w-[85%] shadow-sm">
                      <p className="text-[11px] text-slate-800">
                        Kashmere Gate ISBT, Gate No. 3. Trip leader Arjun will
                        meet you!
                      </p>
                      <span className="text-[8px] text-slate-400 block text-right mt-0.5">
                        9:43 AM
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <div className="bg-[#DCF8C6] rounded-xl rounded-tr-sm px-3 py-1.5 max-w-[75%] shadow-sm">
                      <p className="text-[11px] text-slate-800">
                        Awesome! Can't wait!
                      </p>
                      <div className="flex items-center justify-end gap-0.5 mt-0.5">
                        <span className="text-[8px] text-slate-400">
                          9:44 AM
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-check-circle h-2.5 w-2.5 text-blue-500"
                        >
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                          <path d="m9 11 3 3L22 4" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-start">
                    <div className="bg-white rounded-xl rounded-tl-sm px-3 py-1.5 max-w-[85%] shadow-sm">
                      <p className="text-[11px] text-slate-800">
                        Hotel check-in details sent! Have a great trip. Reach
                        out anytime.
                      </p>
                      <span className="text-[8px] text-slate-400 block text-right mt-0.5">
                        10:15 AM
                      </span>
                    </div>
                  </div>
                </div>
                <div className="bg-[#f0f0f0] px-2.5 py-1.5 flex items-center gap-2 border-t border-slate-200/50">
                  <div className="flex-1 rounded-full bg-white px-3 py-1.5">
                    <p className="text-[10px] text-slate-400">
                      Type a message...
                    </p>
                  </div>
                  <div className="w-7 h-7 rounded-full bg-[#075E54] flex items-center justify-center flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-message-circle h-3.5 w-3.5 text-white"
                    >
                      <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="text-xs text-slate-500 mt-2 text-center">
            Every update on{" "}
            <span className="font-semibold text-[#075E54]">WhatsApp</span> -- no
            app needed
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <div className="group rounded-2xl bg-slate-50 border border-slate-200 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:border-primary/30">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-headphones h-5 w-5 text-white"
                >
                  <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-bold text-slate-900">
                  24/7 Support Team
                </h3>
                <p className="text-xs text-slate-500">
                  Real humans, not bots. Get help within minutes, not hours.
                </p>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
                <span className="text-[10px] text-green-600 font-medium">
                  Online
                </span>
              </div>
            </div>
          </div>
          <div className="group rounded-2xl bg-slate-50 border border-slate-200 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:border-primary/30">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-check-circle h-5 w-5 text-white"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <path d="m9 11 3 3L22 4" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-bold text-slate-900">
                  Verified &amp; Curated Trips
                </h3>
                <p className="text-xs text-slate-500">
                  Every trip is personally vetted. Only quality experiences make
                  the cut.
                </p>
              </div>
              <div className="flex items-center gap-0.5 flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              </div>
            </div>
          </div>
          <div className="group rounded-2xl bg-slate-50 border border-slate-200 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:border-primary/30">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-indian-rupee h-5 w-5 text-white"
                >
                  <path d="M6 3h12" />
                  <path d="M6 8h12" />
                  <path d="m6 13 8.5 8" />
                  <path d="M6 13h3" />
                  <path d="M9 13c6.667 0 6.667-10 0-10" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-bold text-slate-900">
                  No Hidden Charges
                </h3>
                <p className="text-xs text-slate-500">
                  What you see is what you pay. Complete cost breakdowns before
                  you book.
                </p>
              </div>
              <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-shield h-3 w-3 text-primary"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                </svg>
                <span className="text-[10px] text-primary font-medium">
                  Guaranteed
                </span>
              </div>
            </div>
          </div>
          <div className="group rounded-2xl bg-slate-50 border border-slate-200 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:border-primary/30">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-clock h-5 w-5 text-white"
                >
                  <circle cx={12} cy={12} r={10} />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-bold text-slate-900">
                  Real-Time Trip Tracking
                </h3>
                <p className="text-xs text-slate-500">
                  Know exactly where your trip stands. Stay informed every step
                  of the way.
                </p>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <div className="w-12 h-1.5 rounded-full bg-primary/20 overflow-hidden">
                  <div className="h-full w-2/3 rounded-full bg-primary animate-pulse" />
                </div>
                <span className="text-[10px] text-primary font-medium">
                  Live
                </span>
              </div>
            </div>
          </div>
          <div className="group rounded-2xl bg-slate-50 border border-slate-200 p-4 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:border-primary/30">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary flex-shrink-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-book-open h-5 w-5 text-white"
                >
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                </svg>
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-bold text-slate-900">
                  Every Trip Teaches You Something
                </h3>
                <p className="text-xs text-slate-500">
                  Travel is the best education. Our trips are designed to
                  inspire, connect, and transform.
                </p>
              </div>
            </div>
          </div>
          <div className="rounded-2xl bg-gradient-to-r from-[#075E54] to-[#128C7E] p-4 flex items-center justify-between">
            <p className="text-sm font-semibold text-white">
              Your travel partner -- always on WhatsApp.
            </p>
            <a
              href="https://wa.me/918920866123"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="inline-flex items-center justify-center whitespace-nowrap text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-9 rounded-md px-3 bg-white font-semibold text-[#075E54] hover:bg-slate-50 hover:shadow-lg transition-all flex-shrink-0">
                Connect on WhatsApp
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-message-circle ml-1.5 h-3.5 w-3.5"
                >
                  <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                </svg>
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
{/* ./Why Trust New Code */}



               <Homecommunitylist />
            

                
                {/*<HomeLocalocalexpertlist />*/}

                


        <Homereviewlist />




{/*<section className="relative w-full bg-[#0F172A] py-8 sm:py-12 md:py-24 text-white pb-20 md:pb-24">
  <div className="absolute inset-0 z-0 bg-[url('/subtle-pattern.png')] opacity-5 animate-shimmer" />
  <div className="absolute left-0 top-0 h-1 w-full bg-gradient-to-r from-primary/0 via-primary to-primary/0 animate-shimmer" />
  <div className="container relative z-10 mx-auto px-3 sm:px-4 md:px-6">
    <div className="mx-auto max-w-4xl text-center reveal-on-scroll revealed">
      <h2 className="mb-3 sm:mb-4 md:mb-6 text-xl md:text-3xl font-bold tracking-tight text-white sm:text-4xl md:text-5xl">
        Ready to Transform Your{" "}
        <span className="text-gradient">Travel Experience</span>?
      </h2>
      <p className="mb-4 sm:mb-6 md:mb-8 mx-auto max-w-2xl text-xs md:text-base text-slate-300">
        Whether you're looking to connect with fellow travelers or get
        personalized guidance from experts, Connecting Traveller has everything
        you need for authentic and memorable travel experiences.
      </p>
      <div className="flex flex-col items-center justify-center gap-3 sm:gap-4 sm:flex-row pb-10">
        <a href="/community">
          <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-8 w-full sm:w-auto bg-white text-[#0F172A] hover:bg-white/90 transition-all duration-300 hover:scale-105 btn-pulse text-sm md:text-base py-2.5 md:py-3 h-auto rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-users mr-2 h-4 w-4 md:h-5 md:w-5"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx={9} cy={7} r={4} />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            Join Community
          </button>
        </a>
        <a href="/experts">
          <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 px-8 w-full sm:w-auto bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105 btn-pulse text-sm md:text-base py-2.5 md:py-3 h-auto rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-video mr-2 h-4 w-4 md:h-5 md:w-5"
            >
              <path d="m22 8-6 4 6 4V8Z" />
              <rect width={14} height={12} x={2} y={6} rx={2} ry={2} />
            </svg>
            Find an Expert
          </button>
        </a>
      </div>
      <div className="mt-4 sm:mt-8 flex flex-col items-center justify-center gap-2 sm:flex-row">
        <span className="text-xs md:text-sm text-slate-400">
          Already a member?
        </span>
        <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 underline-offset-4 hover:underline h-auto p-0 text-primary hover:text-primary/80 text-xs md:text-sm">
          Sign in to your account
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-right ml-1 h-3 w-3 md:h-4 md:w-4"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div className="absolute bottom-0 left-0 right-0 rotate-180">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 120"
      className="w-full h-auto"
    >
      <path
        fill="#fff"
        fillOpacity={1}
        d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
      />
    </svg>
  </div>
</section>*/}



                

            </main>
        </div>

        <div className='block sm:hidden'>
        
            <main className="flex-1 overflow-auto pb-16">
                <div className="mobile-app-view min-h-screen bg-gray-50">
                   
              
              <HomeBanner/>

                    
                    <div className="overflow-auto pb-5">
                    {activeTab === 'home' && (
                        <div className="home-tab">
                            
                            <section className="px-4 -mt-6 relative z-10 mb-6 hidden">
                                <div className="rounded-lg bg-card text-card-foreground mobile-card shadow-lg border-0">
                                    <div className="p-4">
                                    <div className="flex items-center gap-2 mb-3">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-zap h-4 w-4 text-primary"
                                        >
                                        <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                                        </svg>
                                        <h3 className="font-semibold text-slate-800 text-sm">
                                        Quick Actions
                                        </h3>
                                    </div>
                                    <div className="grid grid-cols-4 gap-2">
                                        <a href="/destinations/categories">
                                        <div className="group text-center">
                                            <div className="w-10 h-10 mx-auto rounded-lg bg-gradient-to-br from-emerald-500 to-green-600 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-200 shadow-md">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-compass h-5 w-5 text-white"
                                            >
                                                <circle cx={12} cy={12} r={10} />
                                                <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" />
                                            </svg>
                                            </div>
                                            <span className="text-xs font-medium text-slate-700">
                                            Explore
                                            </span>
                                        </div>
                                        </a>
                                        <a href="/community">
                                        <div className="group text-center">
                                            <div className="w-10 h-10 mx-auto rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-200 shadow-md">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-users h-5 w-5 text-white"
                                            >
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx={9} cy={7} r={4} />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                            </svg>
                                            </div>
                                            <span className="text-xs font-medium text-slate-700">
                                            Community
                                            </span>
                                        </div>
                                        </a>
                                        <a href="/experts">
                                        <div className="group text-center">
                                            <div className="w-10 h-10 mx-auto rounded-lg bg-gradient-to-br from-purple-500 to-violet-600 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-200 shadow-md">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-video h-5 w-5 text-white"
                                            >
                                                <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
                                                <rect x={2} y={6} width={14} height={12} rx={2} />
                                            </svg>
                                            </div>
                                            <span className="text-xs font-medium text-slate-700">
                                            Experts
                                            </span>
                                        </div>
                                        </a>
                                        <a href="/meetups">
                                        <div className="group text-center">
                                            <div className="w-10 h-10 mx-auto rounded-lg bg-gradient-to-br from-orange-500 to-red-600 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-200 shadow-md">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-calendar h-5 w-5 text-white"
                                            >
                                                <path d="M8 2v4" />
                                                <path d="M16 2v4" />
                                                <rect width={18} height={18} x={3} y={4} rx={2} />
                                                <path d="M3 10h18" />
                                            </svg>
                                            </div>
                                            <span className="text-xs font-medium text-slate-700">
                                            Meetups
                                            </span>
                                        </div>
                                        </a>
                                    </div>
                                    </div>
                                </div>
                            </section>


                            {/* Mob */}



                           <HomeJourneys />

                           <HomeDestinations />

                            {/* <MoHomeupcomingmeet /> */}

                            {/* Group Trip */}
                            


                            <MoHomeupcominggrouptrips />



                            <section className="px-4 mb-10 pb-6 pt-5 border-b border-slate-100">
                              <div className="text-center mb-5">
                                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary/10 border border-primary/20 mb-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-shield h-3 w-3 text-primary"
                                  >
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                                  </svg>
                                  <span className="text-[11px] font-semibold text-primary">
                                    Trusted by 10,000+ Travellers
                                  </span>
                                </div>
                                <h3 className="text-xl font-bold text-slate-800 mb-1">Why Trust Us</h3>
                                <p className="text-xs text-slate-500">
                                  Your travel buddy from booking to landing back home
                                </p>
                              </div>
                              <div className="flex gap-2 mb-5">
                                <div className="flex-1 rounded-xl bg-primary/5 border border-primary/15 p-2.5 text-center">
                                  <p className="text-lg font-bold text-primary">10K+</p>
                                  <p className="text-[10px] text-slate-500">Happy Travellers</p>
                                </div>
                                <div className="flex-1 rounded-xl bg-blue-50 border border-blue-100 p-2.5 text-center">
                                  <p className="text-lg font-bold text-blue-600">24/7</p>
                                  <p className="text-[10px] text-slate-500">Live Support</p>
                                </div>
                                <div className="flex-1 rounded-xl bg-emerald-50 border border-emerald-100 p-2.5 text-center">
                                  <p className="text-lg font-bold text-emerald-600">100%</p>
                                  <p className="text-[10px] text-slate-500">Transparent</p>
                                </div>
                              </div>
                              <div className="flex flex-col items-center mb-5">
                                <div className="w-full max-w-[280px]">
                                  <div className="relative rounded-[2rem] border-[3px] border-slate-800 bg-slate-800 p-1 shadow-xl">
                                    <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-5 bg-slate-800 rounded-b-2xl z-10" />
                                    <div className="rounded-[1.6rem] overflow-hidden bg-[#efeae2]">
                                      <div className="bg-[#075E54] px-3 pt-7 pb-2.5 flex items-center gap-2.5">
                                        <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                                          <span className="text-white text-[10px] font-bold">CT</span>
                                        </div>
                                        <div className="flex-1 min-w-0">
                                          <p className="text-white text-xs font-semibold truncate">
                                            Connecting Traveller
                                          </p>
                                          <p className="text-white/60 text-[9px]">online</p>
                                        </div>
                                      </div>
                                      <div className="px-2.5 py-2.5 space-y-1.5">
                                        <div className="flex justify-center">
                                          <span className="text-[9px] bg-white/80 text-slate-500 px-2.5 py-0.5 rounded-full shadow-sm">
                                            Today
                                          </span>
                                        </div>
                                        <div className="flex justify-start">
                                          <div className="bg-white rounded-xl rounded-tl-sm px-2.5 py-1 max-w-[85%] shadow-sm">
                                            <p className="text-[11px] text-slate-800">
                                              Your Spiti Valley trip is confirmed! Pickup at 6 AM tomorrow.
                                            </p>
                                            <span className="text-[8px] text-slate-400 block text-right mt-0.5">
                                              9:41 AM
                                            </span>
                                          </div>
                                        </div>
                                        <div className="flex justify-end">
                                          <div className="bg-[#DCF8C6] rounded-xl rounded-tr-sm px-2.5 py-1 max-w-[75%] shadow-sm">
                                            <p className="text-[11px] text-slate-800">
                                              Great! What's the pickup point?
                                            </p>
                                            <div className="flex items-center justify-end gap-0.5 mt-0.5">
                                              <span className="text-[8px] text-slate-400">9:42 AM</span>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-check-circle h-2.5 w-2.5 text-blue-500"
                                              >
                                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                <path d="m9 11 3 3L22 4" />
                                              </svg>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex justify-start">
                                          <div className="bg-white rounded-xl rounded-tl-sm px-2.5 py-1 max-w-[85%] shadow-sm">
                                            <p className="text-[11px] text-slate-800">
                                              Kashmere Gate ISBT, Gate No. 3. Trip leader Arjun will meet
                                              you!
                                            </p>
                                            <span className="text-[8px] text-slate-400 block text-right mt-0.5">
                                              9:43 AM
                                            </span>
                                          </div>
                                        </div>
                                        <div className="flex justify-end">
                                          <div className="bg-[#DCF8C6] rounded-xl rounded-tr-sm px-2.5 py-1 max-w-[75%] shadow-sm">
                                            <p className="text-[11px] text-slate-800">
                                              Awesome! Can't wait!
                                            </p>
                                            <div className="flex items-center justify-end gap-0.5 mt-0.5">
                                              <span className="text-[8px] text-slate-400">9:44 AM</span>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-check-circle h-2.5 w-2.5 text-blue-500"
                                              >
                                                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                <path d="m9 11 3 3L22 4" />
                                              </svg>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="flex justify-start">
                                          <div className="bg-white rounded-xl rounded-tl-sm px-2.5 py-1 max-w-[85%] shadow-sm">
                                            <p className="text-[11px] text-slate-800">
                                              Hotel details sent! Have a great trip. Reach out anytime.
                                            </p>
                                            <span className="text-[8px] text-slate-400 block text-right mt-0.5">
                                              10:15 AM
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="bg-[#f0f0f0] px-2.5 py-1.5 flex items-center gap-2 border-t border-slate-200/50">
                                        <div className="flex-1 rounded-full bg-white px-3 py-1">
                                          <p className="text-[10px] text-slate-400">Type a message...</p>
                                        </div>
                                        <div className="w-6 h-6 rounded-full bg-[#075E54] flex items-center justify-center flex-shrink-0">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-message-circle h-3 w-3 text-white"
                                          >
                                            <path d="m3 21 1.9-5.7a8.5 8.5 0 1 1 3.8 3.8z" />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <p className="text-xs text-slate-500 mt-3 text-center">
                                  Every update on{" "}
                                  <span className="font-semibold text-green-600">WhatsApp</span> -- no app
                                  needed
                                </p>
                              </div>
                              <div className="flex gap-3 scrollbar-custom pb-1 -mx-4 px-4 snap-x snap-mandatory">
                                <div className="flex-shrink-0 w-[72%] snap-center rounded-2xl bg-blue-50 border border-blue-100 p-4 shadow-sm">
                                  <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-blue-500 mb-3">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-headphones h-5 w-5 text-white"
                                    >
                                      <path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3" />
                                    </svg>
                                  </div>
                                  <h4 className="text-sm font-bold text-slate-800 mb-1">
                                    24/7 Support Team
                                  </h4>
                                  <p className="text-[11px] text-slate-500 leading-relaxed">
                                    Our dedicated team is always available. Any issue, any time -- real
                                    humans, not bots.
                                  </p>
                                  <div className="flex items-center gap-1.5 mt-3">
                                    <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
                                    <span className="text-[10px] text-green-600 font-medium">
                                      Team online now
                                    </span>
                                  </div>
                                </div>
                                <div className="flex-shrink-0 w-[72%] snap-center rounded-2xl bg-amber-50 border border-amber-100 p-4 shadow-sm">
                                  <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary mb-3">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-check-circle h-5 w-5 text-white"
                                    >
                                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                      <path d="m9 11 3 3L22 4" />
                                    </svg>
                                  </div>
                                  <h4 className="text-sm font-bold text-slate-800 mb-1">
                                    Verified &amp; Curated Trips
                                  </h4>
                                  <p className="text-[11px] text-slate-500 leading-relaxed">
                                    Every trip is personally vetted. Only quality and safe experiences make
                                    the cut.
                                  </p>
                                  <div className="flex items-center gap-1 mt-3">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3 w-3 text-primary fill-primary"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="text-[10px] text-slate-400 ml-1">4.9 avg rating</span>
                                  </div>
                                </div>
                                <div className="flex-shrink-0 w-[72%] snap-center rounded-2xl bg-rose-50 border border-rose-100 p-4 shadow-sm">
                                  <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-rose-500 mb-3">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-indian-rupee h-5 w-5 text-white"
                                    >
                                      <path d="M6 3h12" />
                                      <path d="M6 8h12" />
                                      <path d="m6 13 8.5 8" />
                                      <path d="M6 13h3" />
                                      <path d="M9 13c6.667 0 6.667-10 0-10" />
                                    </svg>
                                  </div>
                                  <h4 className="text-sm font-bold text-slate-800 mb-1">
                                    No Hidden Charges
                                  </h4>
                                  <p className="text-[11px] text-slate-500 leading-relaxed">
                                    What you see is what you pay. Complete cost breakdowns before you book.
                                  </p>
                                  <div className="inline-flex items-center gap-1.5 mt-3 px-2.5 py-1 rounded-full bg-rose-100 w-fit">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-shield h-3 w-3 text-rose-500"
                                    >
                                      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
                                    </svg>
                                    <span className="text-[10px] text-rose-600 font-medium">
                                      Price match guarantee
                                    </span>
                                  </div>
                                </div>
                                <div className="flex-shrink-0 w-[72%] snap-center rounded-2xl bg-cyan-50 border border-cyan-100 p-4 shadow-sm">
                                  <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-cyan-500 mb-3">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-clock h-5 w-5 text-white"
                                    >
                                      <circle cx={12} cy={12} r={10} />
                                      <polyline points="12 6 12 12 16 14" />
                                    </svg>
                                  </div>
                                  <h4 className="text-sm font-bold text-slate-800 mb-1">
                                    Real-Time Trip Tracking
                                  </h4>
                                  <p className="text-[11px] text-slate-500 leading-relaxed">
                                    Know exactly where your trip stands. From departure to return, stay
                                    informed.
                                  </p>
                                  <div className="flex items-center gap-2 mt-3">
                                    <div className="flex-1 h-1 rounded-full bg-cyan-200 overflow-hidden">
                                      <div className="h-full w-2/3 rounded-full bg-cyan-500 animate-pulse" />
                                    </div>
                                    <span className="text-[10px] text-cyan-600 font-medium">Live</span>
                                  </div>
                                </div>
                              </div>
                            </section>






                           {/* City Community */}

                           <MoHomecommunitylist />
                           



                           <MoHomereviewlist />
                            


                            
                            
                        </div>
                    )}
                    {activeTab === 'grouptrips' && (
                        <div className="explore-tab">
                            <div className="group-trips-tab pb-20">
                                <div className="relative overflow-hidden h-52">
                                    <div className="absolute inset-0 w-full h-full">
                                    <img
                                        alt="Group travel adventures"
                                        loading="lazy"
                                        decoding="async"
                                        data-nimg="fill"
                                        className="object-cover"
                                        style={{
                                        position: "absolute",
                                        height: "100%",
                                        width: "100%",
                                        inset: 0,
                                        color: "transparent"
                                        }}
                                        src="/assets/images/tropical-beach-paradise-with-turquoise-water-and-p.jpg"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
                                    </div>
                                    <div className="relative h-full flex flex-col items-center justify-center px-5 py-5">
                                    <div className="text-center space-y-1">
                                        <h2 className="text-white text-sm font-semibold drop-shadow-lg tracking-wide">
                                        UPCOMING
                                        </h2>
                                        <h2
                                        className="text-yellow-400 text-3xl font-extrabold drop-shadow-lg"
                                        style={{
                                            textShadow: "rgba(0, 0, 0, 0.6) 3px 3px 8px",
                                            fontFamily: "system-ui, -apple-system, sans-serif",
                                            letterSpacing: "0.02em"
                                        }}
                                        >
                                        Community
                                        </h2>
                                        <h2 className="text-white text-xl font-semibold drop-shadow-lg tracking-wide">
                                        TRIPS
                                        </h2>
                                        <div className="flex items-center justify-center gap-3 mt-4">
                                        <div className="flex items-center gap-1.5 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-md">
                                            <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-star h-3.5 w-3.5 text-yellow-500 fill-yellow-500"
                                            >
                                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                            </svg>
                                            <span className="text-xs font-bold text-slate-800">4.9</span>
                                        </div>
                                        <div className="flex items-center gap-1.5 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-md">
                                            <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-users h-3.5 w-3.5 text-teal-600"
                                            >
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                            <circle cx={9} cy={7} r={4} />
                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                            </svg>
                                            <span className="text-xs font-bold text-slate-800">
                                            2K+ Travelers
                                            </span>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div className="bg-white border-b px-4 py-3.5">
                                    <div className="flex gap-2 scrollbar-custom pb-1">
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-slate-800 text-white border-slate-800 shadow-sm">
                                        All Months
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Jan-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Feb-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Mar-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Apr-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        May-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Jun-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Jul-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Aug-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Sep-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Oct-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Nov-26
                                    </button>
                                    <button className="px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all border bg-white text-slate-700 border-slate-200 hover:border-slate-300">
                                        Dec-26
                                    </button>
                                    </div>
                                </div>
                                <div className="bg-slate-50 border-b px-4 py-3">
                                    <div className="flex gap-2 mb-3">
                                    <div className="relative flex-[3]">
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none z-10"
                                        >
                                        <circle cx={11} cy={11} r={8} />
                                        <path d="m21 21-4.3-4.3" />
                                        </svg>
                                        <input
                                        placeholder="Search destinations..."
                                        className="pl-10 pr-4 h-10 w-full bg-white border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none text-sm"
                                        type="text"
                                        defaultValue=""
                                        />
                                    </div>
                                    
                                    <button
                                        onClick={() => setShowFilters(!showFilters)}
                                        className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:text-accent-foreground rounded-md bg-white h-10 px-4 flex-shrink-0"
                                    >
                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="h-4 w-4 mr-2"
                                        >
                                        <line x1="4" x2="4" y1="21" y2="14" />
                                        <line x1="4" x2="4" y1="10" y2="3" />
                                        <line x1="12" x2="12" y1="21" y2="12" />
                                        <line x1="12" x2="12" y1="8" y2="3" />
                                        <line x1="20" x2="20" y1="21" y2="16" />
                                        <line x1="20" x2="20" y1="12" y2="3" />
                                        <line x1="2" x2="6" y1="14" y2="14" />
                                        <line x1="10" x2="14" y1="8" y2="8" />
                                        <line x1="18" x2="22" y1="16" y2="16" />
                                        </svg>

                                        Filters

                                        <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className={`h-4 w-4 ml-2 transition-transform ${
                                            showFilters ? "rotate-180" : ""
                                        }`}
                                        >
                                        <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </button>
                                    </div>
                                    <div className="flex gap-2 scrollbar-custom">
                                        <button className="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-teal-600 text-white shadow-sm">
                                            All
                                        </button>
                                        <button className="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200">
                                            Spiti Valley
                                        </button>
                                        <button className="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200">
                                            Meghalaya
                                        </button>
                                        <button className="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200">
                                            Himachal
                                        </button>
                                        <button className="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200">
                                            Ladakh
                                        </button>
                                        <button className="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200">
                                            Kerala
                                        </button>
                                        <button className="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200">
                                            Rajasthan
                                        </button>
                                        <button className="px-4 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200">
                                            Goa
                                        </button>
                                    </div>

                                    {/* FILTER PANEL */}
                                    {showFilters && (
                                        <div className="mt-3 space-y-4 bg-slate-50 rounded-lg p-4">
                                        {/* CATEGORY */}
                                        <div>
                                            <h4 className="text-xs font-semibold text-slate-600 mb-2 uppercase">
                                            Category
                                            </h4>
                                            <div className="flex flex-wrap gap-2">
                                            <button className="px-3 py-1.5 rounded-full text-xs font-medium transition-all bg-teal-600 text-white shadow-md">
                                                All
                                            </button>
                                            {["Adventure", "Nature", "Beach", "Cultural"].map(
                                                (item, i) => (
                                                <button
                                                    key={i}
                                                    className="px-3 py-1.5 rounded-full text-xs font-medium transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200"
                                                >
                                                    {item}
                                                </button>
                                                )
                                            )}
                                            </div>
                                        </div>

                                        {/* BUDGET */}
                                        <div>
                                            <h4 className="text-xs font-semibold text-slate-600 mb-2 uppercase">
                                            Budget
                                            </h4>
                                            <div className="flex flex-wrap gap-2">
                                            <button className="px-3 py-1.5 rounded-full text-xs font-medium transition-all bg-teal-600 text-white shadow-md">
                                                All Budgets
                                            </button>
                                            {["Under ₹25K", "₹25K - ₹40K", "Above ₹40K"].map(
                                                (budget, i) => (
                                                <button
                                                    key={i}
                                                    className="px-3 py-1.5 rounded-full text-xs font-medium transition-all bg-white text-slate-700 hover:bg-slate-100 border border-slate-200"
                                                >
                                                    {budget}
                                                </button>
                                                )
                                            )}
                                            </div>
                                        </div>
                                        </div>
                                    )}
                                </div>
                                <div className="px-4 pb-3 pt-2 bg-slate-50">
                                    <div className="flex items-center justify-between mb-4 mt-4">
                                    <p className="text-sm text-slate-600">6 trips found</p>
                                    </div>
                                    <div className="space-y-4">
                                    <a className="block mb-4" href="/group-trips/1">
                                        <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm">
                                        <div className="relative h-44">
                                            <img
                                            alt="Winter Spiti 4x4 Expedition"
                                            loading="lazy"
                                            decoding="async"
                                            data-nimg="fill"
                                            className="object-cover"
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                inset: 0,
                                                color: "transparent"
                                            }}
                                            src="/coastal-mountain-vista.png"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                            <div className="absolute bottom-3 left-3 right-3">
                                            <h3 className="font-bold text-white text-base mb-1">
                                                Winter Spiti 4x4 Expedition
                                            </h3>
                                            <div className="flex items-center gap-1 text-white/90 text-xs">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-map-pin h-3 w-3"
                                                >
                                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                <circle cx={12} cy={10} r={3} />
                                                </svg>
                                                <span>Spiti Valley</span>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="p-3">
                                            <div className="mb-3">
                                            <p className="text-xs text-slate-500 mb-1.5">Available Dates:</p>
                                            <div className="flex gap-1.5 flex-wrap">
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 10, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 24, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Feb 07, 2026
                                                </span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between text-xs text-slate-600 mb-3">
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-calendar h-3 w-3"
                                                >
                                                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                                <line x1={16} x2={16} y1={2} y2={6} />
                                                <line x1={8} x2={8} y1={2} y2={6} />
                                                <line x1={3} x2={21} y1={10} y2={10} />
                                                </svg>
                                                <span>6N / 7D</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-users h-3 w-3"
                                                >
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx={9} cy={7} r={4} />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                </svg>
                                                <span>4 spots left</span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-xs text-slate-500">Starting from</p>
                                                <p className="text-lg font-bold text-slate-800">₹36,999</p>
                                            </div>
                                            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 rounded-md px-3 bg-gradient-to-r from-primary to-purple-600 text-white h-8">
                                                View Details
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-arrow-right h-3 w-3 ml-1"
                                                >
                                                <path d="M5 12h14" />
                                                <path d="m12 5 7 7-7 7" />
                                                </svg>
                                            </button>
                                            </div>
                                        </div>
                                        </div>
                                    </a>
                                    <a className="block mb-4" href="/group-trips/2">
                                        <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm">
                                        <div className="relative h-44">
                                            <img
                                            alt="Winter Spiti Trip"
                                            loading="lazy"
                                            decoding="async"
                                            data-nimg="fill"
                                            className="object-cover"
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                inset: 0,
                                                color: "transparent"
                                            }}
                                            src="/solo-mountain-vista.png"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                            <div className="absolute bottom-3 left-3 right-3">
                                            <h3 className="font-bold text-white text-base mb-1">
                                                Winter Spiti Trip
                                            </h3>
                                            <div className="flex items-center gap-1 text-white/90 text-xs">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-map-pin h-3 w-3"
                                                >
                                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                <circle cx={12} cy={10} r={3} />
                                                </svg>
                                                <span>Spiti Valley</span>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="p-3">
                                            <div className="mb-3">
                                            <p className="text-xs text-slate-500 mb-1.5">Available Dates:</p>
                                            <div className="flex gap-1.5 flex-wrap">
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 10, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 17, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 24, 2026
                                                </span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between text-xs text-slate-600 mb-3">
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-calendar h-3 w-3"
                                                >
                                                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                                <line x1={16} x2={16} y1={2} y2={6} />
                                                <line x1={8} x2={8} y1={2} y2={6} />
                                                <line x1={3} x2={21} y1={10} y2={10} />
                                                </svg>
                                                <span>6N / 7D</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-users h-3 w-3"
                                                >
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx={9} cy={7} r={4} />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                </svg>
                                                <span>8 spots left</span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-xs text-slate-500">Starting from</p>
                                                <p className="text-lg font-bold text-slate-800">₹18,999</p>
                                            </div>
                                            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 rounded-md px-3 bg-gradient-to-r from-primary to-purple-600 text-white h-8">
                                                View Details
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-arrow-right h-3 w-3 ml-1"
                                                >
                                                <path d="M5 12h14" />
                                                <path d="m12 5 7 7-7 7" />
                                                </svg>
                                            </button>
                                            </div>
                                        </div>
                                        </div>
                                    </a>
                                    <a className="block mb-4" href="/group-trips/3">
                                        <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm">
                                        <div className="relative h-44">
                                            <img
                                            alt="Meghalaya Backpacking"
                                            loading="lazy"
                                            decoding="async"
                                            data-nimg="fill"
                                            className="object-cover"
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                inset: 0,
                                                color: "transparent"
                                            }}
                                            src="/coastal-mountain-vista.png"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                            <div className="absolute bottom-3 left-3 right-3">
                                            <h3 className="font-bold text-white text-base mb-1">
                                                Meghalaya Backpacking
                                            </h3>
                                            <div className="flex items-center gap-1 text-white/90 text-xs">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-map-pin h-3 w-3"
                                                >
                                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                <circle cx={12} cy={10} r={3} />
                                                </svg>
                                                <span>Meghalaya</span>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="p-3">
                                            <div className="mb-3">
                                            <p className="text-xs text-slate-500 mb-1.5">Available Dates:</p>
                                            <div className="flex gap-1.5 flex-wrap">
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 10, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 17, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Feb 07, 2026
                                                </span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between text-xs text-slate-600 mb-3">
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-calendar h-3 w-3"
                                                >
                                                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                                <line x1={16} x2={16} y1={2} y2={6} />
                                                <line x1={8} x2={8} y1={2} y2={6} />
                                                <line x1={3} x2={21} y1={10} y2={10} />
                                                </svg>
                                                <span>5N / 6D</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-users h-3 w-3"
                                                >
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx={9} cy={7} r={4} />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                </svg>
                                                <span>6 spots left</span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-xs text-slate-500">Starting from</p>
                                                <p className="text-lg font-bold text-slate-800">₹22,999</p>
                                            </div>
                                            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 rounded-md px-3 bg-gradient-to-r from-primary to-purple-600 text-white h-8">
                                                View Details
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-arrow-right h-3 w-3 ml-1"
                                                >
                                                <path d="M5 12h14" />
                                                <path d="m12 5 7 7-7 7" />
                                                </svg>
                                            </button>
                                            </div>
                                        </div>
                                        </div>
                                    </a>
                                    <a className="block mb-4" href="/group-trips/4">
                                        <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm">
                                        <div className="relative h-44">
                                            <img
                                            alt="Himachal Short Circuit"
                                            loading="lazy"
                                            decoding="async"
                                            data-nimg="fill"
                                            className="object-cover"
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                inset: 0,
                                                color: "transparent"
                                            }}
                                            src="/solo-mountain-vista.png"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                            <div className="absolute bottom-3 left-3 right-3">
                                            <h3 className="font-bold text-white text-base mb-1">
                                                Himachal Short Circuit
                                            </h3>
                                            <div className="flex items-center gap-1 text-white/90 text-xs">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-map-pin h-3 w-3"
                                                >
                                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                <circle cx={12} cy={10} r={3} />
                                                </svg>
                                                <span>Himachal Pradesh</span>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="p-3">
                                            <div className="mb-3">
                                            <p className="text-xs text-slate-500 mb-1.5">Available Dates:</p>
                                            <div className="flex gap-1.5 flex-wrap">
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 08, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 15, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Feb 05, 2026
                                                </span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between text-xs text-slate-600 mb-3">
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-calendar h-3 w-3"
                                                >
                                                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                                <line x1={16} x2={16} y1={2} y2={6} />
                                                <line x1={8} x2={8} y1={2} y2={6} />
                                                <line x1={3} x2={21} y1={10} y2={10} />
                                                </svg>
                                                <span>4N / 5D</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-users h-3 w-3"
                                                >
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx={9} cy={7} r={4} />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                </svg>
                                                <span>10 spots left</span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-xs text-slate-500">Starting from</p>
                                                <p className="text-lg font-bold text-slate-800">₹17,999</p>
                                            </div>
                                            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 rounded-md px-3 bg-gradient-to-r from-primary to-purple-600 text-white h-8">
                                                View Details
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-arrow-right h-3 w-3 ml-1"
                                                >
                                                <path d="M5 12h14" />
                                                <path d="m12 5 7 7-7 7" />
                                                </svg>
                                            </button>
                                            </div>
                                        </div>
                                        </div>
                                    </a>
                                    <a className="block mb-4" href="/group-trips/5">
                                        <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm">
                                        <div className="relative h-44">
                                            <img
                                            alt="Bali Paradise Retreat"
                                            loading="lazy"
                                            decoding="async"
                                            data-nimg="fill"
                                            className="object-cover"
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                inset: 0,
                                                color: "transparent"
                                            }}
                                            src="/coastal-mountain-vista.png"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                            <div className="absolute bottom-3 left-3 right-3">
                                            <h3 className="font-bold text-white text-base mb-1">
                                                Bali Paradise Retreat
                                            </h3>
                                            <div className="flex items-center gap-1 text-white/90 text-xs">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-map-pin h-3 w-3"
                                                >
                                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                <circle cx={12} cy={10} r={3} />
                                                </svg>
                                                <span>Bali</span>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="p-3">
                                            <div className="mb-3">
                                            <p className="text-xs text-slate-500 mb-1.5">Available Dates:</p>
                                            <div className="flex gap-1.5 flex-wrap">
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 15, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Feb 05, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Feb 20, 2026
                                                </span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between text-xs text-slate-600 mb-3">
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-calendar h-3 w-3"
                                                >
                                                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                                <line x1={16} x2={16} y1={2} y2={6} />
                                                <line x1={8} x2={8} y1={2} y2={6} />
                                                <line x1={3} x2={21} y1={10} y2={10} />
                                                </svg>
                                                <span>7N / 8D</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-users h-3 w-3"
                                                >
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx={9} cy={7} r={4} />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                </svg>
                                                <span>3 spots left</span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-xs text-slate-500">Starting from</p>
                                                <p className="text-lg font-bold text-slate-800">₹45,999</p>
                                            </div>
                                            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 rounded-md px-3 bg-gradient-to-r from-primary to-purple-600 text-white h-8">
                                                View Details
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-arrow-right h-3 w-3 ml-1"
                                                >
                                                <path d="M5 12h14" />
                                                <path d="m12 5 7 7-7 7" />
                                                </svg>
                                            </button>
                                            </div>
                                        </div>
                                        </div>
                                    </a>
                                    <a className="block mb-4" href="/group-trips/6">
                                        <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm">
                                        <div className="relative h-44">
                                            <img
                                            alt="Dubai Desert Safari"
                                            loading="lazy"
                                            decoding="async"
                                            data-nimg="fill"
                                            className="object-cover"
                                            style={{
                                                position: "absolute",
                                                height: "100%",
                                                width: "100%",
                                                inset: 0,
                                                color: "transparent"
                                            }}
                                            src="/manhattan-twilight.png"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                            <div className="absolute bottom-3 left-3 right-3">
                                            <h3 className="font-bold text-white text-base mb-1">
                                                Dubai Desert Safari
                                            </h3>
                                            <div className="flex items-center gap-1 text-white/90 text-xs">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-map-pin h-3 w-3"
                                                >
                                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                <circle cx={12} cy={10} r={3} />
                                                </svg>
                                                <span>Dubai</span>
                                            </div>
                                            </div>
                                        </div>
                                        <div className="p-3">
                                            <div className="mb-3">
                                            <p className="text-xs text-slate-500 mb-1.5">Available Dates:</p>
                                            <div className="flex gap-1.5 flex-wrap">
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 12, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Jan 26, 2026
                                                </span>
                                                <span className="px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs font-medium">
                                                Feb 09, 2026
                                                </span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between text-xs text-slate-600 mb-3">
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-calendar h-3 w-3"
                                                >
                                                <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                                                <line x1={16} x2={16} y1={2} y2={6} />
                                                <line x1={8} x2={8} y1={2} y2={6} />
                                                <line x1={3} x2={21} y1={10} y2={10} />
                                                </svg>
                                                <span>5N / 6D</span>
                                            </div>
                                            <div className="flex items-center gap-1">
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-users h-3 w-3"
                                                >
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <circle cx={9} cy={7} r={4} />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                </svg>
                                                <span>5 spots left</span>
                                            </div>
                                            </div>
                                            <div className="flex items-center justify-between">
                                            <div>
                                                <p className="text-xs text-slate-500">Starting from</p>
                                                <p className="text-lg font-bold text-slate-800">₹52,999</p>
                                            </div>
                                            <button className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 rounded-md px-3 bg-gradient-to-r from-primary to-purple-600 text-white h-8">
                                                View Details
                                                <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="lucide lucide-arrow-right h-3 w-3 ml-1"
                                                >
                                                <path d="M5 12h14" />
                                                <path d="m12 5 7 7-7 7" />
                                                </svg>
                                            </button>
                                            </div>
                                        </div>
                                        </div>
                                    </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {activeTab === 'customizedtrips' && (
                       
                        <>
                            <div className="relative overflow-hidden h-44">
                                <div className="absolute inset-0 w-full h-full">
                                    <img
                                    alt="Customized travel destinations"
                                    loading="lazy"
                                    decoding="async"
                                    data-nimg="fill"
                                    className="object-cover"
                                    style={{
                                        position: "absolute",
                                        height: "100%",
                                        width: "100%",
                                        inset: 0,
                                        color: "transparent"
                                    }}
                                    src="/assets/images/scenic-travel-destination-mountain-lake-sunset.jpg"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
                                </div>
                                <div className="relative h-full flex flex-col items-center justify-center px-4">
                                    <div className="text-center mb-3">
                                    <h1 className="text-xl font-bold text-white mb-1">PLAN YOUR</h1>
                                    <h2 className="text-3xl font-extrabold text-yellow-400 drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
                                        Customized
                                    </h2>
                                    <h1 className="text-xl font-bold text-white">TRIPS</h1>
                                    </div>
                                    <button className="px-4 py-2 bg-white/95 backdrop-blur-sm text-teal-600 rounded-lg text-sm font-semibold shadow-lg hover:bg-white transition-all flex items-center gap-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="lucide lucide-map-pin h-4 w-4"
                                    >
                                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                        <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    Plan Your Trip
                                    </button>
                                </div>
                            </div>

                            <div className="py-4 bg-white border-b mb-3">
                                
                                {/* TOP TABS */}
                                <div className="px-4 flex gap-3 justify-center mb-4">
                                    <button
                                    onClick={() => setTripTab("international")}
                                    className={`flex-1 py-2.5 px-4 rounded-full text-sm font-semibold transition-all ${
                                        tripTab === "international"
                                        ? "bg-teal-500 text-white shadow-md"
                                        : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                                    }`}
                                    >
                                    International
                                    </button>

                                    <button
                                    onClick={() => setTripTab("domestic")}
                                    className={`flex-1 py-2.5 px-4 rounded-full text-sm font-semibold transition-all ${
                                        tripTab === "domestic"
                                        ? "bg-teal-500 text-white shadow-md"
                                        : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                                    }`}
                                    >
                                    Domestic
                                    </button>
                                </div>

                                {/* INTERNATIONAL TAB */}
                                {tripTab === "international" && (
                                    <>
                                    <div className="px-4 py-4 bg-white border-b mb-3 mt-3">
                                        <h4 className="text-xs font-bold text-slate-700 mb-2.5 uppercase tracking-wide">
                                            Select Country
                                        </h4>

                                        <div className="flex gap-2 scrollbar-custom pb-2">
                                            <button className="px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-teal-500 text-white shadow-sm">
                                            All Countries
                                            </button>

                                            {[
                                            "Thailand",
                                            "Maldives",
                                            "UAE",
                                            "Singapore",
                                            "France",
                                            "UK",
                                            "Italy",
                                            "USA",
                                            "Japan",
                                            "Australia",
                                            ].map((country, i) => (
                                            <button
                                                key={i}
                                                className="px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-slate-100 text-slate-700 hover:bg-slate-200"
                                            >
                                                {country}
                                            </button>
                                            ))}
                                        </div>

                                    </div>

                                    <div className="px-4 pb-3 pt-2 bg-slate-50">
                                            <p className="text-xs font-semibold text-slate-700 mb-3 uppercase tracking-wide">
                                                3 Packages Available
                                            </p>
                                            <div className="space-y-5">
                                                <a className="block mb-4" href="/customized-trips/goa-beach-getaway">
                                                <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm hover:shadow-md transition-all border-slate-200">
                                                    <div className="relative h-44">
                                                    <img
                                                        alt="Goa Beach Getaway"
                                                        loading="lazy"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        className="object-cover"
                                                        style={{
                                                        position: "absolute",
                                                        height: "100%",
                                                        width: "100%",
                                                        inset: 0,
                                                        color: "transparent"
                                                        }}
                                                        src="/assets/images/coastal-mountain-vista.png"
                                                    />
                                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                                    <div className="absolute bottom-0 left-0 right-0 p-3">
                                                        <h3 className="font-bold text-white text-sm leading-tight mb-1">
                                                        Goa Beach Getaway
                                                        </h3>
                                                        <div className="flex items-center gap-2 text-xs text-white/90">
                                                        <span className="flex items-center gap-1">
                                                            <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-map-pin h-3 w-3"
                                                            >
                                                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                            <circle cx={12} cy={10} r={3} />
                                                            </svg>
                                                            Goa
                                                        </span>
                                                        <span>•</span>
                                                        <span>5 Days</span>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div className="p-3 bg-white">
                                                    <div className="flex items-center gap-2 text-xs text-slate-600 mb-2">
                                                        <span className="flex items-center gap-1">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-users h-3 w-3"
                                                        >
                                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                            <circle cx={9} cy={7} r={4} />
                                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                        </svg>
                                                        2-4 People
                                                        </span>
                                                        <span>•</span>
                                                        <div className="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 text-[10px] px-1.5 py-0 h-4 bg-teal-50 text-teal-700">
                                                        Domestic
                                                        </div>
                                                    </div>
                                                    <div className="flex items-start gap-2 mb-2.5">
                                                        <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={24}
                                                        height={24}
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="lucide lucide-check-circle h-3 w-3 text-teal-600 mt-0.5 flex-shrink-0"
                                                        >
                                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                        <path d="m9 11 3 3L22 4" />
                                                        </svg>
                                                        <p className="text-xs text-slate-600 line-clamp-2 leading-relaxed">
                                                        Beach resorts • Water sports
                                                        </p>
                                                    </div>
                                                    <div className="flex items-center justify-between pt-2 border-t border-slate-100">
                                                        <div>
                                                        <p className="text-[10px] text-slate-500 uppercase tracking-wide mb-0.5">
                                                            Starting From
                                                        </p>
                                                        <p className="text-sm font-bold text-slate-800">₹25K - ₹40K</p>
                                                        </div>
                                                        <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 rounded-md px-3 h-7 text-xs bg-teal-500 hover:bg-teal-600 text-white">
                                                        Customize
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-chevron-right h-3 w-3 ml-1"
                                                        >
                                                            <path d="m9 18 6-6-6-6" />
                                                        </svg>
                                                        </button>
                                                    </div>
                                                    </div>
                                                </div>
                                                </a>
                                                <a className="block mb-4" href="/customized-trips/rajasthan-heritage">
                                                <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm hover:shadow-md transition-all border-slate-200">
                                                    <div className="relative h-44">
                                                    <img
                                                        alt="Rajasthan Heritage"
                                                        loading="lazy"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        className="object-cover"
                                                        style={{
                                                        position: "absolute",
                                                        height: "100%",
                                                        width: "100%",
                                                        inset: 0,
                                                        color: "transparent"
                                                        }}
                                                        src="/assets/images/eiffel-tower-cityscape.png"
                                                    />
                                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                                    <div className="absolute bottom-0 left-0 right-0 p-3">
                                                        <h3 className="font-bold text-white text-sm leading-tight mb-1">
                                                        Rajasthan Heritage
                                                        </h3>
                                                        <div className="flex items-center gap-2 text-xs text-white/90">
                                                        <span className="flex items-center gap-1">
                                                            <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-map-pin h-3 w-3"
                                                            >
                                                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                            <circle cx={12} cy={10} r={3} />
                                                            </svg>
                                                            Jaipur
                                                        </span>
                                                        <span>•</span>
                                                        <span>6 Days</span>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div className="p-3 bg-white">
                                                    <div className="flex items-center gap-2 text-xs text-slate-600 mb-2">
                                                        <span className="flex items-center gap-1">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-users h-3 w-3"
                                                        >
                                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                            <circle cx={9} cy={7} r={4} />
                                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                        </svg>
                                                        4 People
                                                        </span>
                                                        <span>•</span>
                                                        <div className="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 text-[10px] px-1.5 py-0 h-4 bg-teal-50 text-teal-700">
                                                        Domestic
                                                        </div>
                                                    </div>
                                                    <div className="flex items-start gap-2 mb-2.5">
                                                        <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={24}
                                                        height={24}
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="lucide lucide-check-circle h-3 w-3 text-teal-600 mt-0.5 flex-shrink-0"
                                                        >
                                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                        <path d="m9 11 3 3L22 4" />
                                                        </svg>
                                                        <p className="text-xs text-slate-600 line-clamp-2 leading-relaxed">
                                                        Palaces • Desert safari
                                                        </p>
                                                    </div>
                                                    <div className="flex items-center justify-between pt-2 border-t border-slate-100">
                                                        <div>
                                                        <p className="text-[10px] text-slate-500 uppercase tracking-wide mb-0.5">
                                                            Starting From
                                                        </p>
                                                        <p className="text-sm font-bold text-slate-800">₹35K - ₹50K</p>
                                                        </div>
                                                        <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 rounded-md px-3 h-7 text-xs bg-teal-500 hover:bg-teal-600 text-white">
                                                        Customize
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-chevron-right h-3 w-3 ml-1"
                                                        >
                                                            <path d="m9 18 6-6-6-6" />
                                                        </svg>
                                                        </button>
                                                    </div>
                                                    </div>
                                                </div>
                                                </a>
                                                <a className="block mb-4" href="/customized-trips/kerala-backwaters">
                                                <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm hover:shadow-md transition-all border-slate-200">
                                                    <div className="relative h-44">
                                                    <img
                                                        alt="Kerala Backwaters"
                                                        loading="lazy"
                                                        decoding="async"
                                                        data-nimg="fill"
                                                        className="object-cover"
                                                        style={{
                                                        position: "absolute",
                                                        height: "100%",
                                                        width: "100%",
                                                        inset: 0,
                                                        color: "transparent"
                                                        }}
                                                        src="/assets/images/coastal-mountain-vista.png"
                                                    />
                                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                                                    <div className="absolute bottom-0 left-0 right-0 p-3">
                                                        <h3 className="font-bold text-white text-sm leading-tight mb-1">
                                                        Kerala Backwaters
                                                        </h3>
                                                        <div className="flex items-center gap-2 text-xs text-white/90">
                                                        <span className="flex items-center gap-1">
                                                            <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-map-pin h-3 w-3"
                                                            >
                                                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                                            <circle cx={12} cy={10} r={3} />
                                                            </svg>
                                                            Kerala
                                                        </span>
                                                        <span>•</span>
                                                        <span>5 Days</span>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div className="p-3 bg-white">
                                                    <div className="flex items-center gap-2 text-xs text-slate-600 mb-2">
                                                        <span className="flex items-center gap-1">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-users h-3 w-3"
                                                        >
                                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                            <circle cx={9} cy={7} r={4} />
                                                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                                        </svg>
                                                        2-4 People
                                                        </span>
                                                        <span>•</span>
                                                        <div className="inline-flex items-center rounded-full border font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-secondary/80 text-[10px] px-1.5 py-0 h-4 bg-teal-50 text-teal-700">
                                                        Domestic
                                                        </div>
                                                    </div>
                                                    <div className="flex items-start gap-2 mb-2.5">
                                                        <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width={24}
                                                        height={24}
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth={2}
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        className="lucide lucide-check-circle h-3 w-3 text-teal-600 mt-0.5 flex-shrink-0"
                                                        >
                                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                                                        <path d="m9 11 3 3L22 4" />
                                                        </svg>
                                                        <p className="text-xs text-slate-600 line-clamp-2 leading-relaxed">
                                                        Houseboat stay • Ayurveda
                                                        </p>
                                                    </div>
                                                    <div className="flex items-center justify-between pt-2 border-t border-slate-100">
                                                        <div>
                                                        <p className="text-[10px] text-slate-500 uppercase tracking-wide mb-0.5">
                                                            Starting From
                                                        </p>
                                                        <p className="text-sm font-bold text-slate-800">₹30K - ₹45K</p>
                                                        </div>
                                                        <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 rounded-md px-3 h-7 text-xs bg-teal-500 hover:bg-teal-600 text-white">
                                                        Customize
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width={24}
                                                            height={24}
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth={2}
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            className="lucide lucide-chevron-right h-3 w-3 ml-1"
                                                        >
                                                            <path d="m9 18 6-6-6-6" />
                                                        </svg>
                                                        </button>
                                                    </div>
                                                    </div>
                                                </div>
                                                </a>
                                            </div>
                                    </div>
                                    </>
                                )}

                                {/* DOMESTIC TAB */}
                                {tripTab === "domestic" && (
                                    <>
                                    <div className="px-4 mt-3">
                                        <h4 className="text-xs font-bold text-slate-700 mb-2.5 uppercase tracking-wide">
                                            Select City
                                        </h4>

                                        <div className="flex gap-2 scrollbar-custom pb-2">
                                            <button className="px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-teal-500 text-white shadow-sm">
                                            All Cities
                                            </button>

                                            {[
                                            "Jaipur",
                                            "Goa",
                                            "Udaipur",
                                            "Munnar",
                                            "Varanasi",
                                            "Andaman",
                                            "Shimla",
                                            "Rishikesh",
                                            "Mysore",
                                            "Manali",
                                            "Leh",
                                            "Kerala",
                                            ].map((city, i) => (
                                            <button
                                                key={i}
                                                className="px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all bg-slate-100 text-slate-700 hover:bg-slate-200"
                                            >
                                                {city}
                                            </button>
                                            ))}
                                        </div>
                                        
                                    </div>

                                    <div className="px-4 pb-3 pt-2 bg-slate-50">
                                        <h2 className=''>Domestic</h2>
                                    </div>
                                    </>
                                )}
                            </div>

                        </>

                    )}
                    </div>

                    
                </div>
            </main>
        </div>

      <Footer />
    </>
  );
};

export default Index;